module.exports = __webpack_public_path__ + "static/media/up.7f830b9a.svg";